import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import _rootReducer from "./reducers/_rootReducer";
import thunk from "redux-thunk";
//import LogRocket from 'logrocket';

const middlewares = [thunk];
const initialState = {};
const store = createStore(
  _rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middlewares))
);

export default store;
